// src/components/OfflineDetector.js
import React, { useState, useEffect, useRef } from 'react';

const OfflineDetector = () => {
  const [, setIsOffline] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const hideTimerRef = useRef(null);

  useEffect(() => {
    const handleOnline = () => {
      clearTimeout(hideTimerRef.current);
      setIsOffline(false);
      setShowMessage(false);
    };

    const handleOffline = () => {
      setIsOffline(true);
      setShowMessage(true);

      // Auto-hide after 5 seconds (tracked so it can be cleared)
      clearTimeout(hideTimerRef.current);
      hideTimerRef.current = setTimeout(() => {
        setShowMessage(false);
      }, 5000);
    };

    // Add event listeners
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Cleanup
    return () => {
      clearTimeout(hideTimerRef.current);
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!showMessage) return null;

  return (
    <div style={overlayStyle}>
      <div style={messageBoxStyle}>
        <div style={iconStyle}>📶</div>
        <p style={textStyle}>Connection lost. Please reconnect to continue.</p>
      </div>
    </div>
  );
};

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.7)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999,
  fontFamily: "'Open Sans', sans-serif"
};

const messageBoxStyle = {
  backgroundColor: '#fff',
  padding: '2rem',
  borderRadius: '12px',
  textAlign: 'center',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
  maxWidth: '90%',
  width: '400px',
  border: '2px solid #e74c3c'
};

const iconStyle = {
  fontSize: '3rem',
  marginBottom: '1rem',
  opacity: 0.7
};

const textStyle = {
  margin: 0,
  fontSize: '1.1rem',
  color: '#333',
  fontWeight: '600',
  lineHeight: '1.4'
};

export default OfflineDetector;